module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen6-f8532b915072b92678b6c93b8db7bf0e.png";